import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './App';
import { UploadProvider } from './contexts/UploadContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';
import { setActiveBackendUrl } from './services/api';

// Kick off infra config fetch immediately — before React renders anything.
// Covers landing page + all app pages. Falls back to REACT_APP_API_URL silently.
// In development we deliberately skip the override so local devs always hit
// the backend configured in their .env (the Firestore doc points at prod).
if (process.env.NODE_ENV !== 'development') {
  getDoc(doc(db, 'settings', 'public_infra'))
    .then((snap) => {
      const url = snap.exists() ? snap.data()?.active_backend_url : null;
      if (url) setActiveBackendUrl(url);
    })
    .catch(() => {});
}

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: !!process.env.REACT_APP_SENTRY_DSN,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UploadProvider>
      <App />
    </UploadProvider>
  </React.StrictMode>
);